module.exports = __webpack_public_path__ + "static/media/features3.ae2eb80e.png";